import { createAsyncThunk } from "@reduxjs/toolkit";
import { apiUrl } from "../../../constants";

export const createCustomer = createAsyncThunk(
  "customer/createCustomer",
  async (data, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.user.token;

    const customerData = {
      c_name: data.name,
      c_email: data.email,
      c_phonenumber: data.phone,
      c_address: data.address,
      c_city: data.city,
      c_country: data.country,
      c_postalcode: data.postalcode,
      c_latitude: data.latitude,
      c_longitude: data.longitude,
      dc_id: data.dc_id || "",
      dc_custom_id: data.dc_custom_id || null,
    };

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(customerData),
    };

    try {
      const response = await fetch(`${apiUrl}/create_customer`, requestOptions);

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Customer creation failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
